import { ActionCreator } from 'redux';
import { ThunkAction, Dispatch } from '../../../../types/actions';
import { TBoardId } from '../../../../types/types';
import { ECardField } from '../store/listViewBoard/types';
import { IGetState } from '../../../../types/types';
import { listViewActionSet } from '../store/listView/actions/listViewActionSet';
import { shownFieldsSetAction } from '../store/listViewBoard/actions/shownFieldsSet';
import { setLocalStorageItem } from '../helpers/setLocalStorageItem';
import { getOrderType } from '../selectors/getOrderType';
import { batch } from 'react-redux';
import { orderTypeSetAction } from '../store/listViewBoard/actions/orderTypeSet';
import { showFieldGoogleAnalyticsEvents } from './googleAnalyticsEvents';
import { getListViewBoard } from '../selectors/getListViewBoard';
import { sortingTypeInSettingsSegmentEvent } from './segmentEvents';

export const shownFieldToggle: ActionCreator<ThunkAction> = (
    boardId: TBoardId,
    field: ECardField,
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        let shownFields = [...getListViewBoard(state, boardId).shownFields];
        const index = shownFields.indexOf(field);
        let active = false; // for GA
        dispatch(() => {
            if (index >= 0) {
                shownFields.splice(index, 1); // скрыли поле
                let orderType = getOrderType(state, boardId);
                if ( // если сортировка по этому полю, сбрасывааем сортирорвку
                    orderType &&
                    orderType.field === field
                ) {
                    dispatch(listViewActionSet(boardId, orderTypeSetAction(null)));
                }
            } else {
                shownFields.push(field);
                active = true;
            }
            dispatch(listViewActionSet(boardId, shownFieldsSetAction(shownFields)));
            dispatch(showFieldGoogleAnalyticsEvents(field, active));
            dispatch(sortingTypeInSettingsSegmentEvent(field, active));
        });
        setLocalStorageItem(boardId);
    };
    return action;
};
